import React from 'react';
import { EMOTES, EmoteId } from './EmoteBubble';

interface EmoteMenuProps {
    onSelect: (emoteId: string, type: 'premium' | 'animated') => void;
    onClose: () => void;
    x: number;
    y: number;
    emoteSlots: { id: string, type: 'premium' | 'animated' }[];
}

export const EmoteMenu: React.FC<EmoteMenuProps> = ({ onSelect, onClose, x, y, emoteSlots }) => {
    const radius = 80;

    return (
        <>
            {/* Backdrop to close on click outside */}
            <div
                className="fixed inset-0 z-[100]"
                onClick={onClose}
                onContextMenu={(e) => { e.preventDefault(); onClose(); }}
            />

            {/* Menu Container */}
            <div
                className="absolute z-[101] w-0 h-0 flex items-center justify-center"
                style={{ left: '50%', top: '50%' }}
            >
                {emoteSlots.map((slot, index) => {
                    // Calculate position
                    const angle = (index * (360 / emoteSlots.length) - 90) * (Math.PI / 180); // Start from top
                    const dx = Math.cos(angle) * radius;
                    const dy = Math.sin(angle) * radius;

                    return (
                        <button
                            key={`${slot.id}-${index}`}
                            onClick={() => onSelect(slot.id, slot.type)}
                            className="absolute w-14 h-14 rounded-full bg-gradient-to-b from-[#2F1F1A] to-[#1a1110] border-2 border-[#DAA520] shadow-lg
                         flex items-center justify-center overflow-hidden
                         hover:scale-125 transition-transform duration-200 hover:bg-[#5D4037]
                         animate-pop-in group"
                            style={{
                                transform: `translate(${dx}px, ${dy}px)`,
                            }}
                            title={slot.id}
                        >
                            <img
                                src={`/assets/emotes/${slot.id.toLowerCase()}.png`}
                                alt={slot.id}
                                className="w-full h-full object-cover"
                            />
                        </button>
                    );
                })}

                {/* Center Close Button (optional, or just decorative) */}
                <div className="absolute w-8 h-8 rounded-full bg-slate-800 border-2 border-slate-600 opacity-50 pointer-events-none" />
            </div>
        </>
    );
};
